import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import Session from '../auth/Session';
import AdminFunctions from './AdminFunctions';
import '../layout/site.css';

export class CreateRole extends Component {
    static displayName = CreateRole.name;

    constructor(props) {
        super(props);

        this.state = {
            roleName: '',
            success: undefined
        };

    }

    async componentDidMount() {
        const isAdmin = await AdminFunctions.isAdminAsync();
        if(!isAdmin) {
            this.props.history.push('/accessdenied');
        }        
    }

    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>Create Role</h3>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col xl='10'>
                            <Input
                                type='text'
                                onChange={(e) => this.setState({ roleName: e.target.value })}
                                name='roleName'
                                id='roleName'
                                placeholder='Role Name'
                            />
                        </Col>
                        <Col xl='2'>
                            <Button
                                color='primary'
                                onClick={() => this.createRole()}
                            >
                                Create
                            </Button>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col>
                            {this.state.success === true && (
                                <Alert color='success'>
                                    Role added successfully!
                                </Alert>
                            )}                            
                            {this.state.success === false && (
                                <Alert color='danger'>
                                    Error adding role!
                                </Alert>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    async createRole() {        
        const token = Session.getToken();
        const response = await fetch(
            `api/Admin/CreateRoleAsync?roleName=${encodeURIComponent(this.state.roleName)}`,
            {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            }
        );
        const data = await response.json();
        this.setState({ success: data });
    }

}